// Library Methods
import axios from "axios";

// Utils
import { config, webServiceUrl } from "src/utils/services/servicesHelper";

// Types
import { ClinicType } from "../clinics/types";

const login = async (
  accessToken: string | null,
  emailData: { email: string }
): Promise<Array<ClinicType>> => {
  try {
    const { data } = await axios.post(
      `${webServiceUrl}/auth/clinic`,
      emailData,
      config(accessToken)
    );
    return data?.data;
  } catch (error) {
    throw error;
  }
};

export { login };
